import { useTranslation } from '../../i18n';
import { Button } from '../../button';
import type { ReactElement } from 'react';
import type { ButtonProps } from './types';

export function OperatorButton(props: ButtonProps): ReactElement {
  const [t] = useTranslation();
  const { loading = false, label = t('新建'), type = 'primary', icon = 'PlusOutlined', onClick, disabled } = props;

  return (
    <Button
      label={label}
      type={type}
      icon={icon}
      disabled={disabled}
      onClick={onClick}
      loading={loading}
    />
  );
}
